export default __webpack_public_path__ + "static/media/32t.a6af3066.jpg";